import CompanyHotWalletDetailsTableView from './companyHotWalletDetailsTableView';

export default CompanyHotWalletDetailsTableView;
